var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input"},[_c('Input',_vm._b({attrs:{"type":"password","disabled":_vm._disabled,"controls":false,"size":"medium"},on:{"input":_vm.update}},'Input',{value: _vm.value},false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }